import { reactive } from 'vue'

// alert()/confirm() 대신 쓰는 전역 커스텀 다이얼로그. GlobalDialog.vue가 이 상태를
// 그려주고, 여기 있는 showAlert/showConfirm으로 어디서든 열 수 있다.
export const dialogState = reactive({
  open: false,
  type: 'alert', // 'alert' | 'confirm'
  message: '',
  resolve: null
})

export function showAlert(message) {
  return new Promise((resolve) => {
    dialogState.type = 'alert'
    dialogState.message = message
    dialogState.resolve = resolve
    dialogState.open = true
  })
}

export function showConfirm(message) {
  return new Promise((resolve) => {
    dialogState.type = 'confirm'
    dialogState.message = message
    dialogState.resolve = resolve
    dialogState.open = true
  })
}
